import React, { useState } from "react"; // Adjust import paths as necessary

import { GhostButton } from "@/components/bild/Button/Button";
import { RadioGroup } from "@/components/bild/Radio";
import { TextField } from "@/components/bild/TextField";
import {
  emailRegex,
  nameRegex,
  SALUTATION_NONE_VALUE,
} from "@/components/Form/FormFields";
import { Participant, RegistrationFormInteractionOutro } from "@/service/Model";
import { Icons } from "@/styles";

import * as Styled from "./styles";

type PersonalDetailsProps = {
  formData: Partial<Participant>;
  onChange: (data: Partial<Participant>) => void;
  onNext: () => void;
  outro: RegistrationFormInteractionOutro;
};

const PersonalDetails: React.FC<PersonalDetailsProps> = ({
  formData,
  onChange,
  onNext,
  outro: { outroTitle },
}: PersonalDetailsProps) => {
  const { firstName, lastName, email, gender } = formData;
  const [emailError, setEmailError] = useState("");
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  // Salutation is optional (ESD-2418): it is not part of the "fields are filled" gate.
  const fieldsAreFilled =
    formData.firstName &&
    formData.lastName &&
    formData.email &&
    emailError === "";

  const handleFieldChange = (name: string, value: string) => {
    onChange({ [name]: value });
  };

  const handleEmailChange = (value: string) => {
    handleFieldChange("email", value);
    setEmailError(emailRegex.test(value) ? "" : "Ungültige E-Mail Adresse");
  };

  const handleFirstNameChange = (value: string) => {
    handleFieldChange("firstName", value);
    setFirstNameError(nameRegex.test(value) ? "" : "Ungültiger Vorname");
  };

  const handleLastNameChange = (value: string) => {
    handleFieldChange("lastName", value);
    setLastNameError(nameRegex.test(value) ? "" : "Ungültiger Nachname");
  };

  return (
    <>
      <Styled.Headline>{outroTitle}</Styled.Headline>
      <Styled.Subheader>Persönliche Angaben</Styled.Subheader>
      <Styled.RadioGroupWrapper>
        <RadioGroup
          name="gender"
          options={[
            { label: "Herr", value: "male" },
            { label: "Frau", value: "female" },
            { label: "Divers", value: "diverse" },
            { label: "Keine Angabe", value: SALUTATION_NONE_VALUE },
          ]}
          selectedValue={gender}
          onChange={(value: string) => handleFieldChange("gender", value)}
        />
      </Styled.RadioGroupWrapper>
      <Styled.TextFieldWrapper>
        <TextField
          label="Vorname"
          value={firstName ?? ""}
          name="firstName"
          onChange={handleFirstNameChange}
          error={!!firstNameError}
          errorMessage={firstNameError}
        />
        <TextField
          label="Nachname"
          value={lastName ?? ""}
          name="lastName"
          onChange={handleLastNameChange}
          error={!!lastNameError}
          errorMessage={lastNameError}
        />
        <TextField
          label="E-Mail"
          value={email ?? ""}
          name="email"
          onChange={handleEmailChange}
          error={!!emailError}
          errorMessage={emailError}
        />
      </Styled.TextFieldWrapper>
      <Styled.ButtonWrapper>
        <GhostButton
          dataQA="outro.lightPoll:next"
          disabled={!fieldsAreFilled}
          icon={Icons.PageRight}
          label="Weiter zu Datenschutz"
          onClick={onNext}
        />
      </Styled.ButtonWrapper>
    </>
  );
};

export default PersonalDetails;
